import React, { useEffect, useState, useContext, useCallback } from 'react';
import { message } from 'antd';
import { RouteComponentProps } from '@reach/router';
import {
    LayoutStandardCrud,
    BlockLoading2,
    FiltersDisplay,
} from '@/components';
import _ from 'lodash';
import { StoreContext } from '@/stores';
import { useNet } from '@/utils';
import { observer } from 'mobx-react-lite';
import FormDemoTable from './components/table';
import { ActionDelete } from '@/pages/sales-follow-up/opt/list/components/delete';
import { defaultAuthDeco } from '@/containers/hoc';
import './index.scss';
import FormDrawer from '@/pages/sales-follow-up/opt/list/components/form-drawer';
import { AntButton } from '@/components/antd';
import { CtxProvider } from '@/utils/context';

const OptList: React.FC<RouteComponentProps & {
    onCreate?: any;
    precheckLoading?: boolean;
    drawerData: any;
    type: string;
}> = ({ onCreate, type = 'all', drawerData = {}, precheckLoading }) => {
    const currentCustomer = (drawerData.originData || [])[0] || {};

    const store = useContext(StoreContext);
    const [defaultStore] = useState(() => new store.OptListStore());
    defaultStore.setPosition('customer-drawer');

    const userStore = store.getAuthStore();

    const {
        defaultPagination,
        defaultSorter,
        defaultMeta,
        defaultPerm,
        defaultFilter,
    } = defaultStore;

    const { confirmedfilterData } = defaultFilter;

    const { paginationForFetch } = defaultPagination;

    const { sortersForFetch } = defaultSorter;

    const LeadListFetch = useCallback(() => defaultStore.fetch(), []);
    const [error, loading, reload] = useNet(LeadListFetch, {
        autoLoad: false,
        refreshKeys: ['opt'],
    });

    const [preRequiredReady, setPreRequiredReady] = useState(false);

    useEffect(() => {
        if (!currentCustomer.id) {
            return;
        }
        defaultStore.setDefaultFilters([
            {
                fieldId: 'customer_id',
                filterValue: currentCustomer.id,
                operateType: '=',
                parser: 'string',
            },
        ]);
    }, [drawerData]);

    // 翻页
    useEffect(() => {
        // 元信息，准备用户可查询的
        if (!preRequiredReady || !currentCustomer.id) {
            return;
        }
        reload();
    }, [
        paginationForFetch,
        sortersForFetch,
        confirmedfilterData,
        preRequiredReady,
    ]);

    useEffect(() => {
        if (userStore.userInfo) {
            defaultMeta.setTableId('opportunity'); // TOFIX TODO: 动态设置
            defaultMeta.setOpUsername(userStore.userInfo.userId + '-' + type);
            Promise.all([defaultMeta.fetch(), defaultPerm.fetch()])
                .then(() => {
                    setPreRequiredReady(true);
                })
                .catch(() => {}); // 初始化元信息
        }
    }, [userStore.userInfo]);

    // 设置filter初始值
    useEffect(() => {
        if (defaultMeta.inited) {
            defaultFilter.resetFilterData();
            defaultFilter.confirmFilterData();
        }
    }, [defaultMeta.inited]);

    useEffect(() => {
        defaultStore.setListType(type);
        defaultStore.setDefaultFields([
            'opportunity_sale_stage',
            'contract_id',
        ]);
    }, [type]);

    if (!preRequiredReady) {
        return <BlockLoading2 />;
    }

    const filtersDisplay = (
        <FiltersDisplay
            objectMeta={defaultMeta.objectMeta}
            filterData={confirmedfilterData}
            sorterData={defaultStore.defaultSorter}
            onClose={(key: string) => {
                defaultFilter.onFilterClear(key);
            }}
        />
    );

    const popups = (
        <>
            <ActionDelete defaultStore={defaultStore} />
            <CtxProvider
                ctx={{ position: 'list', positionDetail: 'custom-opt-table' }}
            >
                <FormDrawer
                    defaultStore={defaultStore}
                    preRequiredReady={preRequiredReady}
                />
            </CtxProvider>
        </>
    );

    const title = null;
    const globalOps = (
        <>
            {defaultPerm.getPermByTypeAndAction(defaultStore.listType)('create')
                .visible && (
                <div style={{ height: 49 }}>
                    <AntButton
                        loading={!!precheckLoading}
                        onClick={() => {
                            onCreate && onCreate();
                        }}
                    >
                        新建商机
                    </AntButton>
                </div>
            )}
        </>
    );
    const multipleOps = null;

    const dataTable = (
        <FormDemoTable defaultStore={defaultStore} loading={loading} />
    );

    const layoutComs = {
        popups,
        title,
        globalOps,
        filters: null,
        multipleOps,
        dataTable,
        message: null,
        filtersDisplay,
    };

    return <LayoutStandardCrud className="opt-tab" {...layoutComs} />;
};

const FinalOptList = defaultAuthDeco(observer(OptList));
export default FinalOptList;
